
import React from 'react';
import { Check, AlertTriangle, X } from 'lucide-react';
import { TableCell, TableRow } from '@/components/ui/table';
import { useLanguage } from '@/components/i18n/language-provider';

interface ComparisonTableRowProps {
  feature: string;
  keystle: {
    icon: 'check' | 'alert' | 'x';
    text: string;
  };
  auth0: {
    icon: 'check' | 'alert' | 'x';
    text?: string;
  };
  keycloak: {
    icon: 'check' | 'alert' | 'x';
    text: string;
  };
}

const ComparisonTableRow: React.FC<ComparisonTableRowProps> = ({
  feature,
  keystle,
  auth0,
  keycloak
}) => {
  const { t } = useLanguage();

  const renderIcon = (type: 'check' | 'alert' | 'x') => {
    switch (type) {
      case 'check':
        return <Check className="h-5 w-5 text-green-500 mr-2" />;
      case 'alert':
        return <AlertTriangle className="h-5 w-5 text-amber-500 mr-2" />;
      case 'x':
        return <X className="h-5 w-5 text-red-500 mr-2" />;
    }
  };

  return (
    <TableRow>
      <TableCell className="font-medium">{t(feature)}</TableCell>
      <TableCell className="bg-primary/5">
        <div className="flex items-center">
          {renderIcon(keystle.icon)}
          {keystle.text && <span>{t(keystle.text)}</span>}
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {renderIcon(auth0.icon)}
          {auth0.text && <span>{t(auth0.text)}</span>}
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {renderIcon(keycloak.icon)}
          {keycloak.text && <span>{t(keycloak.text)}</span>}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ComparisonTableRow;
